module.exports = __webpack_public_path__ + "static/media/indexBack.1ddefe08.jpg";